__turbopack_context__.v({
  "carousel-card": "resumeJourneyCarousel-module-scss-module__fjkdQq__carousel-card",
  "carousel-con": "resumeJourneyCarousel-module-scss-module__fjkdQq__carousel-con",
  "carousel-container": "resumeJourneyCarousel-module-scss-module__fjkdQq__carousel-container",
  "chevron-con": "resumeJourneyCarousel-module-scss-module__fjkdQq__chevron-con",
  "cross-con": "resumeJourneyCarousel-module-scss-module__fjkdQq__cross-con",
  "header-con": "resumeJourneyCarousel-module-scss-module__fjkdQq__header-con",
  "hidden": "resumeJourneyCarousel-module-scss-module__fjkdQq__hidden",
  "indicator-con": "resumeJourneyCarousel-module-scss-module__fjkdQq__indicator-con",
  "main-con": "resumeJourneyCarousel-module-scss-module__fjkdQq__main-con",
  "text-header-con": "resumeJourneyCarousel-module-scss-module__fjkdQq__text-header-con",
});
